<template>
  <HomePanel ref="target" title="卫生专业技术资格">
    <template v-slot:right>
      <div class="sub">
        <RouterLink target="_blank" to="/video?firstCate=202">
          <el-button plain>卫生初级职称</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/video?firstCate=198">
          <el-button plain>卫生中级职称</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/video?firstCate=189">
          <el-button plain>卫生副高级职称</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/video?firstCate=180">
          <el-button plain>卫生正高级职称</el-button>
        </RouterLink>
      </div>
      <ShMore to="/video" />
    </template>
    <div class="box">
      <Transition name="fade">
        <template v-if="sideImg.length">
          <RouterLink
            target="_blank"
            class="cover"
            :to="`${sideImg[1]?.bannerUrl}`"
          >
            <img v-lazy="sideImg[1]?.bannerImg" :alt="sideImg[1]?.bannerDesc" />
          </RouterLink>
        </template>
        <SideImgSkeleton v-else />
      </Transition>
      <LessonItem :goods="goods" />
    </div>
  </HomePanel>
</template>

<script>
import SideImgSkeleton from "./side-img-skeleton.vue";
import LessonItem from "./lesson-item.vue";
import HomePanel from "./home-panel.vue";
import ShMore from "@/components/library/sh-more.vue";
import { ref } from "vue";
import { useLazyData } from "@/hooks";
import { findZhiCheng } from "@/api/home";

export default {
  name: "HomeLesson",
  components: {
    HomePanel,
    ShMore,
    LessonItem,
    SideImgSkeleton,
  },
  props: {
    sideImg: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    //获取职称数值中的随机数
    const target = ref(null);

    let zhicheng = [202, 198, 189, 180];
    function getRandomNumber(arr) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      return arr[randomIndex];
    }
    const randomchID = getRandomNumber(zhicheng);
    //获取首页职称数据
    const { result } = useLazyData(target, () => findZhiCheng(randomchID));
    return { goods: result, target };
  },
};
</script>

<style scoped lang="less">
.home-product {
  background: #fff;

  .sub {
    margin-bottom: 2px;
    a {
      padding: 2px 12px;
      font-size: 16px;
      border-radius: 4px;
      &:last-child {
        margin-right: 80px;
      }
    }
  }
  .box {
    display: flex;
    .cover {
      width: 240px;
      height: 610px;
      //margin-right: 10px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
